const fetchConfig = {
  method: "POST",
  headers: { "Content-Type": "application/json", Accept: `application/json` },
};
const CONNECTION_VERIFICATION_MESSAGE =
  window.FoxThemeStrings.connectionVerification;
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
        if (!cartItems) return;
        const itemContainer = this.closest(".f-cart-drawer__item, .f-cart-item");
        const varId = itemContainer?.getAttribute("data-cart-item-variant-id");
         cartItems.updateQuantity(this.dataset.index, 0, null, this, varId);
         }, { capture: true });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.cart = null;
    this.bundleBatchRequestInFlight = false;
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.initLoading();
    this.addEventListener("change", debouncedOnChange.bind(this));

    // Hard block checkout interactions while bundled removal is in progress.
    this.onCheckoutClickGuard = this.onCheckoutClickGuard.bind(this);
    this.onCheckoutSubmitGuard = this.onCheckoutSubmitGuard.bind(this);
    document.addEventListener("click", this.onCheckoutClickGuard, true);
    document.addEventListener("submit", this.onCheckoutSubmitGuard, true);
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = window.FoxThemeEvents.subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      async (parsedState) => {
        if (window.FoxThemeSettings.template === "cart") {
          this.renderContents(parsedState);
        }
        const cart = await FoxThemeCartHelpers.getState();
        if (cart) {
          this.cart = cart;
          FoxThemeCartHelpers.updateCartCount(cart.item_count);
        }
      }
    );

    window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, (cart) => {
      this.cart = cart;
      FoxThemeCartHelpers.updateCartCount(cart.item_count);
      this.classList.toggle("is-empty", cart.item_count === 0);
    });

    window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, (cart) => {
      this.classList.toggle("is-empty", cart.item_count === 0);
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }

     document.removeEventListener("click", this.onCheckoutClickGuard, true);
    document.removeEventListener("submit", this.onCheckoutSubmitGuard, true);
  }

  onCheckoutClickGuard(event) {
    if (!document.documentElement.classList.contains("bundle-removal-in-progress"))
      return;
    const checkoutButton = event.target.closest("[data-checkout-button]");
    const viewCartButton = event.target.closest("[data-view-cart-button]");
    if (!checkoutButton && !viewCartButton) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  onCheckoutSubmitGuard(event) {
    if (!document.documentElement.classList.contains("bundle-removal-in-progress"))
      return;
    const submitter = event.submitter;
    if (submitter && submitter.matches("[data-checkout-button], [name='checkout']")) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const formId = event.target && event.target.id;
    if (formId === "cart" || formId === "CartDrawer") {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  initLoading() {
    this.loading = new window.FoxTheme.AnimateLoading(document.body, {
      overlay: this.querySelector(".f-cart__items"),
    });
  }

   isRateLimitedResponse(response) {
    return response?.status === 429 || response?.status === 403;
  }

  getCartErrorMessageFromResponse(response) {
    if (this.isRateLimitedResponse(response)) {
      return CONNECTION_VERIFICATION_MESSAGE;
    }
    return window.FoxThemeStrings.cartError;
  }

  onChange(event) {
    if (event.target.getAttribute("name") !== "updates[]") return;
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, ele, varId) {
    // Bundled/stringing groups use a single `/cart/update` batch (see removeBundleMembersInOneRequest).
    // Checkout is disabled during that flow. Normal removals use `/cart/change` below.
    // Guard: while bundled batch removal is in progress, ignore additional remove attempts.
    // This prevents duplicate click storms from triggering parallel cart mutations.
    if (window.__bundleRemovalInProgress && Number(quantity) === 0) return;

    let combinedVariantId;

    const isRemoving = Number(quantity) === 0;
    let isBundleRemoval = false;

    // Group identity for the whole stringing bundle is the `_unique_id`
    // stored in `data-cart-item-property`.
    const itemContainer =
      ele && ele.closest
        ? ele.closest(".f-cart-drawer__item") || ele.closest(".f-cart-item")
        : null;

    if (isRemoving && itemContainer) {
      combinedVariantId = (itemContainer.getAttribute(
        "data-cart-item-property"
      ) || "").trim();

      if (combinedVariantId) {
        const itemSelector = itemContainer.classList.contains(
          "f-cart-drawer__item"
        )
          ? ".f-cart-drawer__item"
          : ".f-cart-item";

        const bundleMembers = Array.from(
          document.querySelectorAll(itemSelector)
        ).filter(
          (each) =>
            (each.getAttribute("data-cart-item-property") || "").trim() ===
            combinedVariantId
        );

        isBundleRemoval = bundleMembers.length > 1;
      }
    }

    // Bundle removal in a single request:
    // remove all cart lines that share the same `data-cart-item-property`.
    if (isBundleRemoval && !window.__bundleRemovalInProgress) {
      window.__bundleRemovalInProgress = true;
      this.removeBundleMembersInOneRequest(combinedVariantId);
      return;
    }

    if (window.__bundleRemovalInProgress) {
      // Track all chained requests while bundle removal flow is active
      window.__bundleRemovalDepth = (window.__bundleRemovalDepth || 0) + 1;
      document.documentElement.classList.add("bundle-removal-in-progress");
      document.querySelectorAll("[data-checkout-button]").forEach((btn) => {
        btn.setAttribute("disabled", "disabled");
        btn.setAttribute("aria-disabled", "true");
        btn.classList.add("btn--disabled");
      });
      const viewCartButtons = document.querySelectorAll("[data-view-cart-button]");
      if (viewCartButtons.length > 0) {
        viewCartButtons.forEach((btn) => {
          btn.setAttribute("aria-disabled", "true");
          btn.setAttribute("tabindex", "-1");
          btn.classList.add("btn--disabled");
        });
      }
    }
    this.enableLoading();

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    },
   );

    fetch(`${FoxThemeSettings.routes.cart_change_url}`, {
      ...fetchConfig,
      ...{ body },
    })
.then(async (response) => {
        const state = await response.text();
        if (!response.ok) {
          const error = new Error(this.getCartErrorMessageFromResponse(response));
          error.userMessage = this.getCartErrorMessageFromResponse(response);
          throw error;
        }
        return state;
      })
      .then((state) => {
         let parsedState;
        try {
          parsedState = JSON.parse(state);
        } catch (e) {
          const error = new Error(window.FoxThemeStrings.cartError);
          error.userMessage = window.FoxThemeStrings.cartError;
          throw error;
        }

        const updatedLine = this.querySelector(
          `#CartItem-${line}, #CartDrawer-Item-${line}`
        );

        const quantityElement = updatedLine.querySelector('[name="updates[]"]');
        const items = document.querySelectorAll(".f-cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        const cartDrawer = document.querySelector("cart-drawer");

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawer)
          cartDrawer.classList.toggle("is-empty", parsedState.item_count === 0);

        this.renderContents(parsedState);

            // renderContents can replace checkout buttons; keep them disabled while bundle removal is in progress
        if (window.__bundleRemovalInProgress) {
          document.querySelectorAll("[data-checkout-button]").forEach((btn) => {
            btn.setAttribute("disabled", "disabled");
            btn.setAttribute("aria-disabled", "true");
            btn.classList.add("btn--disabled");
          });
          const viewCartButtons = document.querySelectorAll("[data-view-cart-button]");
          if (viewCartButtons.length > 0) {
            viewCartButtons.forEach((btn) => {
              btn.setAttribute("aria-disabled", "true");
              btn.setAttribute("tabindex", "-1");
              btn.classList.add("btn--disabled");
            });
          }
        }

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;

        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.FoxThemeStrings.cartError;
          } else {
            message = window.FoxThemeStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }

        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawer
            ? trapFocus(cartDrawer, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawer) {
          //TODO: Check later
          // trapFocus(cartDrawer.querySelector('.drawer__inner-empty'), cartDrawer.querySelector('a'));
        } else if (document.querySelector(".f-cart-item") && cartDrawer) {
          trapFocus(cartDrawer, document.querySelector(".f-cart-item__name"));
        }
        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, parsedState);



      })
      .catch((error) => {
        const errors = document.querySelector(
          "#cart-errors, #CartDrawer-CartErrors"
        );
        if (errors) {
          errors.textContent = error?.userMessage || window.FoxThemeStrings.cartError;
        }
      })
      .finally(() => {
        this.loading.finish();

         if (window.__bundleRemovalInProgress) {
          window.__bundleRemovalDepth = Math.max(
            (window.__bundleRemovalDepth || 1) - 1,
            0
          );
        }

        // Re-enable only when entire chained removal flow is fully done.
        if (window.__bundleRemovalInProgress && window.__bundleRemovalDepth === 0) {
          window.__bundleRemovalInProgress = false;
          document.documentElement.classList.remove(
            "bundle-removal-in-progress"
          );
          document.querySelectorAll("[data-checkout-button]").forEach((btn) => {
            btn.removeAttribute("disabled");
            btn.removeAttribute("aria-disabled");
            btn.classList.remove("btn--disabled");
          });
          const viewCartButtons = document.querySelectorAll("[data-view-cart-button]");
          if (viewCartButtons.length > 0) {
            viewCartButtons.forEach((btn) => {
              btn.removeAttribute("aria-disabled");
              btn.removeAttribute("tabindex");
              btn.classList.remove("btn--disabled");
            });
          }
        }
      });
  }

  removeBundleMembersInOneRequest(combinedVariantId) {
    if (this.bundleBatchRequestInFlight) return;
    this.bundleBatchRequestInFlight = true;

    const combined = (combinedVariantId || "").trim();
    const isDrawerContext = !!this.closest("cart-drawer");
    const itemSelector = isDrawerContext ? ".f-cart-drawer__item" : ".f-cart-item";

    const bundleMembers = Array.from(document.querySelectorAll(itemSelector)).filter(
      (each) =>
        (each.getAttribute("data-cart-item-property") || "").trim() === combined
    );

    // IMPORTANT: `/cart/update(.js)` supports line-item keys.
    // Use `item.key` (`data-cart-item`) so removal is precise even when
    // multiple bundles contain same variant ids.
    const updates = {};
    bundleMembers.forEach((member) => {
      const lineItemKey = (member.getAttribute("data-cart-item") || "").trim();
      const variantId = (member.getAttribute("data-cart-item-variant-id") || "").trim();
      if (lineItemKey) {
        updates[String(lineItemKey)] = 0;
      } else if (variantId) {
        // Fallback for any edge markup missing data-cart-item
        updates[String(variantId)] = 0;
      }
    });

    // Track this batch request and block checkout interactions.
    window.__bundleRemovalDepth = (window.__bundleRemovalDepth || 0) + 1;
    document.documentElement.classList.add("bundle-removal-in-progress");
    document.querySelectorAll("[data-checkout-button]").forEach((btn) => {
      btn.setAttribute("disabled", "disabled");
      btn.setAttribute("aria-disabled", "true");
      btn.classList.add("btn--disabled");
    });
    const viewCartButtons = document.querySelectorAll("[data-view-cart-button]");
    if (viewCartButtons.length > 0) {
      viewCartButtons.forEach((btn) => {
        btn.setAttribute("aria-disabled", "true");
        btn.setAttribute("tabindex", "-1");
        btn.classList.add("btn--disabled");
      });
    }

    this.enableLoading();

    if (Object.keys(updates).length === 0) {
      this.loading.finish();
      window.__bundleRemovalDepth = Math.max(
        (window.__bundleRemovalDepth || 1) - 1,
        0
      );
      if (window.__bundleRemovalInProgress && window.__bundleRemovalDepth === 0) {
        window.__bundleRemovalInProgress = false;
        document.documentElement.classList.remove("bundle-removal-in-progress");
        document.querySelectorAll("[data-checkout-button]").forEach((btn) => {
          btn.removeAttribute("disabled");
          btn.removeAttribute("aria-disabled");
          btn.classList.remove("btn--disabled");
        });
        const viewCartButtons = document.querySelectorAll("[data-view-cart-button]");
        if (viewCartButtons.length > 0) {
          viewCartButtons.forEach((btn) => {
            btn.removeAttribute("aria-disabled");
            btn.removeAttribute("tabindex");
            btn.classList.remove("btn--disabled");
          });
        }
      }
      return;
    }

    const sectionsToRender = Array.from(
      new Set(
        this.getSectionsToRender().map((section) => section.section).filter(Boolean)
      )
    );

    const body = JSON.stringify({
      updates,
      sections: sectionsToRender,
      sections_url: window.location.pathname,
    });

    const executeBatchUpdate = (attempt = 0) => {
      return fetch(`${FoxThemeSettings.routes.cart_update_url}`, {
        ...fetchConfig,
        ...{ body },
      }).then(async (response) => {
        const state = await response.text();
        const shouldRetry = response.status === 429 && attempt < 2;

        if (shouldRetry) {
          const delay = 700 * (attempt + 1);
          await new Promise((resolve) => setTimeout(resolve, delay));
          return executeBatchUpdate(attempt + 1);
        }

        if (!response.ok) {
          const error = new Error(this.getCartErrorMessageFromResponse(response));
          error.userMessage = this.getCartErrorMessageFromResponse(response);
          throw error;
        }

        let parsedState;
        try {
          parsedState = JSON.parse(state);
        } catch (e) {
          const error = new Error(window.FoxThemeStrings.cartError);
          error.userMessage = window.FoxThemeStrings.cartError;
          throw error;
        }

        if (parsedState.errors) {
          // Let the existing cart error UI handle messaging by triggering a regular flow.
          const errors = document.querySelector("#cart-errors, #CartDrawer-CartErrors");
          if (errors) errors.textContent = parsedState.errors;
          return null;
        }

        const cartDrawer = document.querySelector("cart-drawer");
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartFooter = document.getElementById("main-cart-footer");
        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawer)
          cartDrawer.classList.toggle("is-empty", parsedState.item_count === 0);

        this.renderContents(parsedState);

        if (window.__bundleRemovalInProgress) {
          document.querySelectorAll("[data-checkout-button]").forEach((btn) => {
            btn.setAttribute("disabled", "disabled");
            btn.setAttribute("aria-disabled", "true");
            btn.classList.add("btn--disabled");
          });
          const viewCartButtons = document.querySelectorAll("[data-view-cart-button]");
          if (viewCartButtons.length > 0) {
            viewCartButtons.forEach((btn) => {
              btn.setAttribute("aria-disabled", "true");
              btn.setAttribute("tabindex", "-1");
              btn.classList.add("btn--disabled");
            });
          }
        }

        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, parsedState);
        return parsedState;
      });
    };

    executeBatchUpdate()
      .catch((error) => {
        const errors = document.querySelector("#cart-errors, #CartDrawer-CartErrors");
        if (errors)
          errors.textContent =
            error?.userMessage || window.FoxThemeStrings.cartError;
      })
      .finally(() => {
        this.loading.finish();

        if (window.__bundleRemovalInProgress) {
          window.__bundleRemovalDepth = Math.max(
            (window.__bundleRemovalDepth || 1) - 1,
            0
          );
        }

        if (window.__bundleRemovalInProgress && window.__bundleRemovalDepth === 0) {
          window.__bundleRemovalInProgress = false;
          document.documentElement.classList.remove("bundle-removal-in-progress");
          document.querySelectorAll("[data-checkout-button]").forEach((btn) => {
            btn.removeAttribute("disabled");
            btn.removeAttribute("aria-disabled");
            btn.classList.remove("btn--disabled");
          });
          const viewCartButtons = document.querySelectorAll("[data-view-cart-button]");
          if (viewCartButtons.length > 0) {
            viewCartButtons.forEach((btn) => {
              btn.removeAttribute("aria-disabled");
              btn.removeAttribute("tabindex");
              btn.classList.remove("btn--disabled");
            });
          }
        }
        this.bundleBatchRequestInFlight = false;
      });
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);
      if (elementToReplace) {
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      }
    });
  }

  updateLiveRegions(line, message) {
    if (!message) return;
    const lineItemError = this.querySelector(
      `#CartItem-${line}, #CartDrawer-Item-${line}`
    );

    window.FoxTheme.Notification.show({
      target: lineItemError.querySelector(
        ".f-cart-item__quantity, .f-cart-drawer__error"
      ),
      method: "appendChild",
      type: "warning",
      message: message,
      last: 5000,
    });

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    const domParser = new DOMParser().parseFromString(html, "text/html");
    return domParser.querySelector(selector)
      ? domParser.querySelector(selector).innerHTML
      : "";
  }

  enableLoading() {
    this.loading.start();
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
}

customElements.define("cart-items", CartItems);
